import Vue from 'vue'
import Router from 'vue-router'
import error from '@/components/404.vue'
import baseUrlApi from '../api/api.js'




import axios from 'axios'
import qs from 'qs'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'



import msbHome from "@/views/msb/home.vue";
import msbPayOrder from "@/views/msb/payOrder.vue";


import wxHome from "@/views/wx/home.vue";
import wxPayOrder from "@/views/wx/payOrderW.vue";
import resultPay from "@/views/wx/resultPay.vue";
import transList from "@/views/wx/transList.vue";
Vue.use(LoadingPlugin)
Vue.use(Router)
const router = new Router({
/* mode: 'history',*/
routes: [

{
path: '/error',
name: 'error',
component: error
},


{
path: '/msb/home', /*publicwx/electCard/received/cardHome*/
name: 'msbHome',
meta: {
msbAuth: true,
title:"首页"
},
component: msbHome
},
{
path: '/msb/payOrder', /*publicwx/electCard/received/cardHome*/
name: 'msbPayOrder',
meta: {
msbAuth: true,
title:"缴费"
},
component: msbPayOrder
},
{
path: '/wx/home', /*publicwx/electCard/received/cardHome*/
name: 'wxHome',
meta: {
wxAuth: true,
title:"首页"
},
component: wxHome
},
{
path: '/wx/payOrderW', /*publicwx/electCard/received/cardHome*/
name: 'wxPayOrder',
meta: {
wxAuth: true,
title:"缴费"
},
component: wxPayOrder
},
{
path: '/wx/resultPay', /*publicwx/electCard/received/cardHome*/
name: 'resultPay',
meta: {

title:"缴费"
},
component: resultPay
},
{
path: '/wx/transList', /*publicwx/electCard/received/cardHome*/
name: 'transList',
meta: {
wxAuth: true,
title:"缴费记录"
},
component: transList
},

]
})
function delCookie() {
var cookies = document.cookie.split(";");
for (var i = 0; i < cookies.length; i++) {
var cookie = cookies[i];
var eqPos = cookie.indexOf("=");
var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
document.cookie =
name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
}
if (cookies.length > 0) {
for (var i = 0; i < cookies.length; i++) {
var cookie = cookies[i];
var eqPos = cookie.indexOf("=");
var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
var domain = location.host.substr(location.host.indexOf("."));
document.cookie =
name +
"=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=" +
domain;
}
}
}
function getvar(paraName){
var url = document.location.toString();
var reg = new RegExp("&amp;|&amp%3B","g");
url = url.replace(reg,"&");
var arrObj = url.split("?");

if (arrObj.length > 1) {
if (arrObj.length > 2){
arrObj[1] = arrObj[2] + "&" + arrObj[1]
}

var arrPara = arrObj[1].split("&");
var arr;

for (var i = 0; i < arrPara.length; i++) {
arr = arrPara[i].split("=");

if (arr != null && arr[0] == paraName) {
return arr[1];
}
}
return "";
}
else {
return "";
}



/*  var url = document.location.toString()
var reg = new RegExp("&amp;|&amp%3B","g");
url = url.replace(reg,"&");
var arrObj = url.split("#");
var pap = arrObj[1].split("?");
var pstr = pap[1].split('&');
for (var i = pstr.length - 1; i >= 0; i--) {
var tep = pstr[i].split("=");
if(tep[0] == paraName){
console.log( tep[1]);
}
}*/
}




router.beforeEach((to, from, next) => {
if (to.meta.title) {
document.title = to.meta.title
}

let cusId=getvar('cusid')
let wxbaseurl = window.location.href;
if (to.matched.some(res => res.meta.msbAuth)) {

if(!Vue.$cookies.get("commercialNumber")){
Vue.$cookies.set("commercialNumber",getvar('commercialNumber'))
}
else{

}

if(to.name=='msbHome'){


if(Vue.$cookies.get("commercialNumber")!=getvar("commercialNumber")){
Vue.$cookies.set("commercialNumber",getvar("commercialNumber"),"1d")
Vue.$cookies.set("msbToken", '')
}
else{

}

}

Vue.$cookies.set('category', 'msb', "1d")

if (!Vue.$cookies.get("msbToken")) {



let code = getvar('code')/*wxbaseurl.substring(
wxbaseurl.indexOf("=") + 1,
wxbaseurl.indexOf("&")
);*/



let params = {
code: getvar("code"),
url: wxbaseurl,
commercialNumber:Vue.$cookies.get("commercialNumber")
};
console.log(params);
axios({
method: "post",
url: baseUrlApi.baeurlWeb+"/api/msb/token" /*!/login*/,//heatapi.allinpaynmg.cn
data: params,
timeout: 180000,
dataType: "json",
headers: {
"X-Requested-With": "XMLHttpRequest",
'Content-Type': 'application/json'
}
}).then(response => {
console.log(response);
if (response.data.code == "0000") {
if(code==''||code==null){
let appid=response.data.data.payAppid
let origin =  window.location.href;
let urlNow =encodeURIComponent(origin)

let url = "https://app.zwfw.nmg.gov.cn:4443/icity/auth2.0/authorize?app_id="+appid+"&redirect_uri="+urlNow+"&scope=auth_user&state="

window.location.href = url
}
else{
Vue.$cookies.set("msbToken", response.data.data.token.token, "1h");
Vue.$cookies.set("commercialName", response.data.data.commercialName, "1d");
Vue.$cookies.set("dataSource", response.data.data.dataSource, "1d");
Vue.$cookies.set("contactNo", response.data.data.contactNo, "1d");
}

Vue.$vux.loading.hide()
next();

} /*else if (response.data.code == "A1001") {
let redirecturl = response.data.data;
window.location.href = redirecturl;*/
else if(response.data.code == 'A1001'||response.data.code == '404'){
Vue.$vux.loading.hide()
Vue.$cookies.set("msbToken", '')
location.reload()
}
else {
Vue.$vux.loading.hide()
Vue.$vux.toast.show({
text: response.data.msg,
type: "warn"
});
next({
path: "/error"
});
}
});

}
else {

next();
}


}
else if (to.matched.some(res => res.meta.wxAuth)) {
console.log('999999')

if(!cusId){
cusId=Vue.$cookies.get("commercialNo")
}
else{

}
if(Vue.$cookies.get("commercialNo")===cusId){

}
else{
delCookie()
}
if(to.name=='wxHome'){
Vue.$cookies.set("payType",getvar('payType'), "1d")
}
else{

}

console.log("wxToken", Vue.$cookies.get("wxToken"));
if (!Vue.$cookies.get("wxToken")) {

let params = {
code: getvar("code"),
url: wxbaseurl,


commercialNumber: cusId
};
console.log(params);
axios({
method: "post",
url: baseUrlApi.baeurlWeb+"/api/wechat/login" /*!/login*/,//heatapi.allinpaynmg.cn
data: params,
timeout: 180000,
dataType: "json",
headers: {
'Content-Type': 'application/json',


}
}).then(response => {
console.log(response);
if (response.data.code == "0000") {
Vue.$cookies.set("userToken", response.data.data.token, "1d");
Vue.$cookies.set("wxToken", response.data.data.token, "1d");
Vue.$cookies.set("commercialName", response.data.data.commercialName, "1d");

Vue.$cookies.set("commercialNo", cusId, "1d");
next();

} else if (response.data.code == "A1001") {
let redirecturl = response.data.data;
window.location.href = redirecturl;
} else {
Vue.$vux.toast.show({
text: response.data.msg,
type: "warn"
});
next({
path: "/error"
});
}
});
} else {

next();
}
}
else {

if (to.matched.length === 0) { //匹配前往的路由不存在
from.name ? next({name: from.name}) : next('/error');
} else {
next(); 
}
}

}
)

export default router



// WEBPACK FOOTER //
// ./src/router/index.js